import { Upload, CalendarClock, Landmark } from "lucide-react";
import { Reveal } from "./Reveal";

const STEPS = [
  {
    id: "step-1-card",
    icon: Upload,
    num: "Paso 1",
    title: "Registra tus cuentas por cobrar",
    body: "Sube un CSV, toma una foto de tu factura o usa el formulario rápido. En 10 minutos tienes toda tu cartera cargada.",
  },
  {
    id: "step-2-card",
    icon: CalendarClock,
    num: "Paso 2",
    title: "Configura tu secuencia de aviso",
    body: "Elige cuándo avisar: 3 días antes, el día del vencimiento y 2 días después. YateAviso redacta y envía por ti.",
  },
  {
    id: "step-3-card",
    icon: Landmark,
    num: "Paso 3",
    title: "Recibe tu dinero",
    body: "Los pagos llegan directo a tu cuenta bancaria o billetera digital. Sin intermediarios, sin comisiones escondidas.",
  },
];

export const HowItWorks = () => (
  <section id="como-funciona" data-testid="how-it-works-section" className="border-y border-white/5 bg-[#131316]/40">
    <div className="mx-auto max-w-6xl px-4 py-24 sm:px-6 lg:py-32">
      <Reveal>
        <p className="mono mb-4 text-xs uppercase tracking-[0.2em] text-emerald-400">Cómo funciona</p>
        <h2 className="font-display max-w-2xl text-2xl font-bold leading-snug tracking-tight sm:text-3xl lg:text-4xl">
          De la factura al cobro en tres movimientos.
        </h2>
      </Reveal>

      <div className="relative mt-16 grid gap-10 lg:grid-cols-3 lg:gap-8">
        <div className="absolute left-6 top-0 hidden h-full w-px bg-gradient-to-b from-emerald-500/50 via-white/10 to-transparent lg:left-0 lg:top-8 lg:h-px lg:w-full lg:bg-gradient-to-r lg:block" />
        {STEPS.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.15}>
            <article data-testid={s.id} className="group relative pl-16 lg:pl-0 lg:pt-16">
              <span className="absolute left-0 top-0 flex h-12 w-12 items-center justify-center rounded-2xl border border-emerald-500/30 bg-[#0A0A0C] text-emerald-400 transition-transform duration-500 group-hover:scale-110 lg:left-0">
                <s.icon className="h-5 w-5" />
              </span>
              <p className="mono text-[11px] uppercase tracking-[0.2em] text-orange-400">{s.num}</p>
              <h3 className="font-display mt-2 text-xl font-semibold tracking-tight">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-400">{s.body}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
